import { STATUS_STYLES, POD_STYLES, labelOf } from "@/lib/api";

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-700";
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${cls}`}>
      {labelOf(status)}
    </span>
  );
}

export function PodBadge({ status }) {
  const cls = POD_STYLES[status] || "bg-slate-100 text-slate-700";
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${cls}`}>
      {labelOf(status)}
    </span>
  );
}
